/**
 * Created by XuQiang on 2017/5/23.
 */
import request from '../utils/request';

export const fetchMenu = ({ locale }) => {
  const uri = `/iwork/menuInfo/getMenu?lang=${locale}`;
  return request(uri);
}; 

export const fetchMonitorServer = ({ locale }) => {
  const uri = `/smartmeeting/smart/policy/getMonitorServer?lang=${locale}`;
  return request(uri);
};



// WEBPACK FOOTER //
// ./src/services/menu.js